import React, { useState, useEffect } from "react";
import SideBar from "../../components/SideBar";
import Header from "../../components/Header";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TablePagination, // Import the TablePagination component
} from "@mui/material";

import Footer from "../../components/Footer";
import ItemsList from "./ItemsList";
import ItemsForm from "./ItemsForm";
import { toast } from "react-toastify";

function CreateItems() {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL;
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isItemModalOpen, setItemModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page

  // Fetch items and categories
  const fetchData = async () => {
    try {
      const itemResponse = await axios.get(
        `${API_BASE_URL}/Menu_category/all_item`
      );
      if (itemResponse.status === 200) {
        setItems(itemResponse.data.items || []);
      } else {
        toast(itemResponse.data.message || "Failed to fetch menu items.");
      }

      const categoryResponse = await axios.get(
        `${API_BASE_URL}/Menu_category/all`
      );
      if (categoryResponse.status === 200) {
        setCategories(categoryResponse.data.items || []);
      } else {
        toast(categoryResponse.data.message || "Failed to fetch categories.");
      }
    } catch (err) {
      toast("An error occurred while fetching data.");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredItems = selectedCategory
    ? items.filter((item) => item.category === selectedCategory)
    : items;

  const openAddItemModal = () => {
    setSelectedItem(null);
    setItemModalOpen(true);
  };

  const openEditItemModal = (item) => {
    setSelectedItem(item);
    setItemModalOpen(true);
  };

  const handleDeleteItem = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Menu_category/soft_delete_item/${itemToDelete.id}`
      );
      if (response.status === 200) {
        toast("Item deleted successfully!");
        fetchData();
      } else {
        toast("Failed to delete item.");
      }
    } catch (err) {
      toast("An error occurred while deleting the item.");
    } finally {
      setDeleteDialogOpen(false);
    }
  };

  const openDeleteDialog = (item) => {
    setItemToDelete(item);
    setDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setItemToDelete(null);
  };

  // Handle pagination changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page is changed
  };

  return (
    <>
      <SideBar />
      <Header />
      <div className="MainContainer">
        <div className="MenuHeader">
          <FormControl
            variant="outlined"
            size="small"
            style={{ width: "200px" }}
          >
            <InputLabel id="category-select-label">
              Filter by Category
            </InputLabel>
            <Select
              labelId="category-select-label"
              id="filter"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              label="Filter by Category"
              defaultValue=""
              size="small"
            >
              <MenuItem value="">
                <em>All</em>
              </MenuItem>
              {categories.map((category) => (
                <MenuItem key={category.id} value={category.id}>
                  {category.category_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div className="ADDBUTTON">
            <Button
              variant="contained"
              color="primary"
              onClick={openAddItemModal}
              size="small"
            >
              Add New Items
            </Button>
          </div>
        </div>
        <ItemsList
          items={filteredItems.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
          )}
          handleDeleteItem={openDeleteDialog}
          openEditItemModal={openEditItemModal}
          categories={categories}
        />

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredItems.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Dialog open={isItemModalOpen} onClose={() => setItemModalOpen(false)}>
          <DialogTitle>
            {selectedItem ? "Edit Item" : "Add New Item"}
          </DialogTitle>
          <DialogContent>
            <ItemsForm
              selectedItem={selectedItem}
              setItemModalOpen={setItemModalOpen}
              fetchItems={fetchData}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setItemModalOpen(false)} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={isDeleteDialogOpen} onClose={closeDeleteDialog}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <p>Are you sure you want to delete this item?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDeleteDialog} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleDeleteItem} color="primary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Footer />
    </>
  );
}

export default CreateItems;
